// extracted by mini-css-extract-plugin
export default {"relation":"RelationTotals_relation__oDecN","metric":"RelationTotals_metric__xNTDo"};